export default __webpack_public_path__ + "static/media/CloseIcon.4da02b6e.svg";